import { render, staticRenderFns } from "./onPten.vue?vue&type=template&id=4048e78a&scoped=true"
import script from "./onPten.vue?vue&type=script&lang=js"
export * from "./onPten.vue?vue&type=script&lang=js"
import style0 from "./onPten.vue?vue&type=style&index=0&id=4048e78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048e78a",
  null
  
)

export default component.exports